document.addEventListener('DOMContentLoaded', function () {
  /* ============================================
   * GA4 helper (works with gtag or GTM dataLayer)
   * ============================================ */
  function sendGA(eventName, params) {
    try {
      if (typeof gtag === 'function') {
        gtag('event', eventName, params || {});
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: eventName,
          ...params
        });
      }
    } catch (e) {
      // silently ignore analytics errors
    }
  }

  /* ==================================================
   * Build discount lookup { vendorLower: {vendor,code,url} }
   * window.GM_DISCOUNTS must be populated in the Liquid
   * (we already output it in the A–Z page template)
   * ================================================== */
  const discountLookup = {};
  if (Array.isArray(window.GM_DISCOUNTS)) {
    window.GM_DISCOUNTS.forEach(entry => {
      if (entry && entry.vendor) {
        discountLookup[String(entry.vendor).toLowerCase()] = entry;
      }
    });
  }

  /* =========================
   * Modal element references
   * ========================= */
  const modal       = document.getElementById('gmModal');
  const closeBtn    = document.getElementById('gmClose');
  const codeEl      = document.getElementById('gmCode');
  const copyBtn     = document.getElementById('gmCopy');
  const shopBtn     = document.getElementById('gmShop');
  const brandNameEl = document.getElementById('gmBrandName');

  function normalizeUrl(u) {
    if (!u) return '';
    const s = String(u).trim();
    if (/^https?:\/\//i.test(s)) return s;
    if (/^\/\//.test(s)) return 'https:' + s;
    return 'https://' + s.replace(/^\/+/, '');
  }

  function openModal(entry) {
    if (!modal) return;

    const brand = entry.vendor || '—';
    const code  = entry.code || '—';
    const dest  = normalizeUrl(entry.discountcode_url || '');

    if (brandNameEl) brandNameEl.textContent = brand;
    if (codeEl)      codeEl.textContent      = code;

    if (shopBtn) {
      if (dest) {
        shopBtn.href = dest;
        shopBtn.target = '_blank';
        shopBtn.rel = 'noopener';
        shopBtn.style.display = '';
        shopBtn.style.pointerEvents = 'auto';
      } else {
        shopBtn.removeAttribute('href');
        shopBtn.style.display = 'none';
      }
    }

    // show the modal
    modal.style.display = 'flex';

    // GA4: modal impression
    sendGA('discount_modal_shown', {
      brand: brand,
      discount_code: code,
      destination_url: dest || ''
    });
  }

  function closeModal() {
    if (modal) modal.style.display = 'none';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  window.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });

  /* =========================
   * Copy button + GA tracking
   * ========================= */
  if (copyBtn) {
    copyBtn.addEventListener('click', () => {
      const code  = (codeEl?.textContent || '').trim();
      const brand = (brandNameEl?.textContent || 'Unknown').trim();
      if (!code || code === '—') return;

      // Copy to clipboard (existing UX)
      navigator.clipboard?.writeText(code).then(() => {
        const original = copyBtn.textContent;
        copyBtn.textContent = 'Copied! 🎉';
        setTimeout(() => (copyBtn.textContent = original), 1200);
      });

      // GA4: copy event
      sendGA('copy_discount_code', {
        brand: brand,
        discount_code: code
      });
    });
  }

  /* =========================
   * Shop button + GA tracking
   * ========================= */
  if (shopBtn) {
    shopBtn.addEventListener('click', () => {
      const brand = (brandNameEl?.textContent || 'Unknown').trim();
      const code  = (codeEl?.textContent || '').trim();
      const url   = shopBtn.href || '';

      // GA4: outbound click (let browser open in new tab)
      sendGA('shop_the_fit_click', {
        brand: brand,
        discount_code: code,
        destination_url: url
      });
    });
  }

  /* =========================================================
   * Event delegation: any click on a vendor opens the modal
   * Target elements:
   *   - .gm-discount-link  (if you added explicit links)
   *   - .designer-item     (your A–Z vendor rows)
   * Each must have data-vendor="Vendor Name"
   * ========================================================= */
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.gm-discount-link, .designer-item');
    if (!trigger) return;

    const vendorRaw = trigger.getAttribute('data-vendor') || '';
    const entry = discountLookup[vendorRaw.toLowerCase()];
    if (!entry) return; // no code mapped—do nothing (or fall back to default)

    e.preventDefault(); // prevent navigation
    openModal({ vendor: vendorRaw, ...entry });
  });


  /* =========================================================
   * OPTIONAL: If you previously had a hover flyout under GIRL MATH
   * and removed it, you can keep the header simple by ensuring
   * there are no mouseenter/mouseleave handlers here.
   * This file intentionally has no header dropdown logic now.
   * ========================================================= */
});
